module.exports = __webpack_public_path__ + "img/404.52244936.svg";